export default __webpack_public_path__ + "static/media/the-prodigy_-_narayan.c198c927.mp3";